import { Box, Divider, Grid2, Typography } from "@mui/material";
import { useState } from "react";
import openAccStyles from "./OpenAccountWeb.module.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import en from "../../../i18n/English/Home/openAccount.json";
import hi from "../../../i18n/Hindi/Home/openAccount.json";
import kn from "../../../i18n/Kannada/Home/openAccount.json";
import ma from "../../../i18n/Marathi/Home/openAccount.json";
import gu from "../../../i18n/Gujarati/Home/openAccount.json"
import { useLanguage } from "../../../Context/LangContext";
export default function OpenAccountWebView() {
  const translations = { en, hi, kn,ma,gu };
  const { language } = useLanguage();
  const t = translations[language];
  return (
    <>
      <Grid2 className={openAccStyles.webaccount}>
        <Grid2 container>

          <Grid2 size={{ sm: 6 }} className={openAccStyles.mainGrid}>
            <AnimationOnScroll animateIn="animate__fadeInLeft"
              animateOnce={true}
              className={openAccStyles.customFadeInLeft}

                >
            <Grid2 className={openAccStyles.subGrid}>
              <Typography className={openAccStyles.honestText}
                  dangerouslySetInnerHTML={{ __html: t.honestHeading }} style={{ fontWeight: 600 }}>
                {/* We bring to you fair and <br />
                honest pricing */}

              </Typography>
              <Typography className={openAccStyles.pricing}
                  dangerouslySetInnerHTML={{ __html: t.pricingTitle }}>
                {/* Pricing */}
                </Typography>
              <Typography className={openAccStyles.rupees}>₹0</Typography>
                <Typography className={openAccStyles.charges} dangerouslySetInnerHTML={{ __html: t.accountCharges }}>
                {/* Account Opening Charges */}
              </Typography>
              <Divider
                className={openAccStyles.divider}
                orientation="horizontal"
              />
            </Grid2>
            <Grid2 className={openAccStyles.subGrid} sx={{paddingTop:"103px"}}>
                <Typography className={openAccStyles.getStarted} dangerouslySetInnerHTML={{ __html: t.getStarted }} style={{ fontWeight: 600 }}>
                {/* Hey, let's get you set up with a trading account! */}
              </Typography>
                <Typography className={openAccStyles.discover} dangerouslySetInnerHTML={{ __html: t.discover }}>
                {/* Discover the blend of tech and traditional trading. */}
              </Typography>
              <Box className={openAccStyles.download}>
                  <Box className={openAccStyles.googlePlay} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.triveni.xts&pcampaignid=web_share')} />
                  <Box className={openAccStyles.appStore} onClick={() => window.open('https://apps.apple.com/in/app/tradeboss-broking/id6753873589')} />
              </Box>
            </Grid2>
            </AnimationOnScroll>
          </Grid2>

          <Grid2 size={{ sm: 6 }}>
            <AnimationOnScroll
              animateIn="animate__fadeInRight"
              className={openAccStyles.customFadeInLeft}
              animateOnce={true}

            >

              <Box className={openAccStyles.stocksMobile}></Box>
          </AnimationOnScroll >

          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}
